/*
* 智慧办公
* */

// 场馆预约
const VenueManagementList = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/venue/VenueManagementList.vue')
const VenueManagementDetail = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/venue/VenueManagementDetail.vue')
const VenueMyAppointmentList = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/venue/VenueMyAppointmentList.vue')
const VenueMyAppointmentDetail = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/venue/VenueMyAppointmentDetail.vue')

// 会议管理
const MeetingMangerList = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/meetings/MeetingMangerList.vue')
const MeetingMangerDetail = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/meetings/MeetingManagerDetail.vue')
const MyMeeting = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/meetings/MyMeeting.vue')
const MyMeetingDetail = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/meetings/MyMeetingDetail.vue')


// 文件管理
const FileList = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/file/FileList.vue')

// 工资管理s
const WageList = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/wage/WageList.vue')

// 维修管理
const RepairAuditeList = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/repair/RepairAuditeList.vue')
const RepairAuditeDetail = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/repair/RepairAuditeDetail.vue')
const RepairReportCreate = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/repair/RepairReportCreate.vue')
const RepairReportList = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/repair/RepairReportList.vue')
const RepairReportDetail = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/repair/RepairReportDetail.vue')

// 问卷管理
const QuestionNaireAdminister = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/questionnaire/QuestionNaireAdminister.vue')
// 我的问卷
const MyQuestionNaire = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/questionnaire/MyquestionNaire.vue')
const QuestionnaireUserOptions = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/questionnaire/QuestionnaireUserOptions.vue')
// 日程管理
const Calendar = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/calendar/Calendar.vue')
// 通讯录
const Address = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/address/Address.vue')
// 参观预约
const Visit = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/visit/Visit.vue')
// 预约的申请
const AboutVisit = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/visit/AboutVisit.vue')
// // 查看
const Examine = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/visit/Examine.vue')

// // 站内信
const Mail = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/mail/Mail.vue')
//公文流转
const Doc = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/documentMove/Doc.vue')
const DocLaunch = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/documentMove/DocLaunch.vue')
const Launch = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/documentMove/Launch.vue')
const Details = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/documentMove/Details.vue')
const DocRecord = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/documentMove/DocRecord.vue')

// 公文审批
const Official = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/official/Official.vue')
const Approval = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/official/Approval.vue')
const Record = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/official/Record.vue')
const File = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/official/File.vue')
const Detail = () => import( /* webpackChunkName: "operationalAnalysis" */ '@/pages/operationalAnalysis/views/official/OfficeDetail.vue')

const operationalAnalysis = [
  {
    path: 'venueManagementList',
    name: 'venueManagementList',
    component: VenueManagementList,
  },
  {
    path: 'venueMyAppointmentList',
    name: 'venueMyAppointmentList',
    component: VenueMyAppointmentList,
  },
  {
    path: 'venueManagementDetail/:id',
    name: 'venueManagementDetail',
    component: VenueManagementDetail,
  },
  {
    path: 'venueMyAppointmentDetail/:id',
    name: 'venueMyAppointmentDetail',
    component: VenueMyAppointmentDetail,
  },
  {
    path: 'meetingMangerList',
    name: 'meetingMangerList',
    component: MeetingMangerList,
  },
  {
    path: 'meetingMangerDetail/:id',
    name: 'meetingMangerDetail',
    component: MeetingMangerDetail,
  },
  {
    path: 'myMeeting',
    name: 'myMeeting',
    component: MyMeeting,
  },
  {
    path: 'myMeetingDetail/:id',
    name: 'myMeetingDetail',
    component: MyMeetingDetail,
  },

  {
    path: 'fileList',
    name: 'fileList',
    component: FileList,
  },
  {
    path: 'wageList',
    name: 'wageList',
    component: WageList,
  },
  {
    path: 'repairAuditeList',
    name: 'repairAuditeList',
    component: RepairAuditeList,
  },
  {
    path: 'repairAuditeDetail',
    name: 'repairAuditeDetail',
    component: RepairAuditeDetail,
  },
  {
    path: 'repairReportCreate',
    name: 'repairReportCreate',
    component: RepairReportCreate,
  },
  {
    path: 'repairReportList',
    name: 'repairReportList',
    component: RepairReportList,
  },
  {
    path: 'repairReportDetail',
    name: 'repairReportDetail',
    component: RepairReportDetail,
  },
  {
    path: 'questionNaireAdminister',
    name: 'questionNaireAdminister',
    component: QuestionNaireAdminister,
  },
  {
    path: 'myQuestionNaire',
    name: 'myQuestionNaire',
    component: MyQuestionNaire,
  },
  {
    path: 'questionnaireUserOptions',
    name: 'questionnaireUserOptions',
    component: QuestionnaireUserOptions,
  },
  {
    path: 'calendar',
    name: 'calendar',
    component: Calendar,
  },
  {
    path: 'address',
    name: 'address',
    component: Address,
  },
  {
    path: 'visit',
    name: 'visit',
    component: Visit,
  },
  {
    path: 'aboutVisit',
    name: 'aboutVisit',
    component: AboutVisit,
  },
  {
    path: 'examine',
    name: 'examine',
    component: Examine,
  },
  {
    path: 'mail',
    name: 'mail',
    component: Mail,
  },
  {
    path: 'doc',
    name: 'doc',
    component: Doc,
    children: [
      {
        path: 'docLaunch',
        name: 'docLaunch',
        component: DocLaunch
      },
      {
        path: 'Launch',
        name: 'Launch',
        component: Launch
      },
      {
        path: 'Details',
        name: 'Details',
        component: Details
      },
      {
        path: 'docRecord',
        name: 'docRecord',
        component: DocRecord
      }
    ]
  },
  {
    path: 'official',
    name: 'official',
    component: Official,
    children: [
      {
        path: 'approval',
        name: 'approval',
        component: Approval
      },
      {
        path: 'record',
        name: 'record',
        component: Record
      },
      {
        path: 'file',
        name: 'file',
        component: File
      },
      {
        path: 'detail',
        name: 'detail',
        component: Detail
      },
    ]
  }
]
export default operationalAnalysis
